import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user: (() => {
      try { return JSON.parse(localStorage.getItem('user') || '{}') }
      catch (_) { return {} }
    })(),
    unreadNoticeCount: 0
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userRole: state => state.user.role || '',
    userName: state => state.user.real_name || state.user.name || '',
    isAdmin: state => state.user.role === 'admin',
    isProvinceAgent: state => state.user.role === 'province',
    isCityAgent: state => state.user.role === 'city',
    isCountyAgent: state => state.user.role === 'county',
    isTownAgent: state => state.user.role === 'town',
    isCustomer: state => state.user.role === 'customer'
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    },
    SET_REFRESH_TOKEN(state, refreshToken) {
      if (refreshToken) {
        localStorage.setItem('refresh_token', refreshToken)
      } else {
        localStorage.removeItem('refresh_token')
      }
    },
    SET_USER(state, user) {
      state.user = user
      if (user && Object.keys(user).length > 0) {
        localStorage.setItem('user', JSON.stringify(user))
      } else {
        localStorage.removeItem('user')
      }
    },
    SET_UNREAD_COUNT(state, count) {
      state.unreadNoticeCount = count
    },
    LOGOUT(state) {
      state.token = ''
      state.user = {}
      state.unreadNoticeCount = 0
      localStorage.removeItem('token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('user')
    }
  },
  actions: {
    login({ commit }, { token, refresh_token, user }) {
      commit('SET_TOKEN', token)
      if (refresh_token) {
        commit('SET_REFRESH_TOKEN', refresh_token)
      }
      commit('SET_USER', user)
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
    updateUser({ commit }, user) {
      commit('SET_USER', user)
    }
  }
})
